import SpaceDashboardOutlinedIcon from "@mui/icons-material/SpaceDashboardOutlined";
import ShieldOutlinedIcon from "@mui/icons-material/ShieldOutlined";
import AssessmentOutlinedIcon from "@mui/icons-material/AssessmentOutlined";
import FactCheckOutlinedIcon from "@mui/icons-material/FactCheckOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";

export const canApprove = (user) =>
  user?.results?.risk_manager === "Administrator" ||
  user?.results?.risk_manager === "Approver";

export function navItems(user) {
  return [
    { text: "Dashboard", to: "/insurance/", icon: <SpaceDashboardOutlinedIcon /> },
    { text: "Insurance", to: "/insurance/new-insurance", icon: <ShieldOutlinedIcon /> },
    { text: "Report", to: "/insurance/report", icon: <AssessmentOutlinedIcon /> },
    ...(canApprove(user)
      ? [{ text: "Approvals", to: "/insurance/approvals", icon: <FactCheckOutlinedIcon />, badge: "approvals" }]
      : []),
    { text: "Settings", to: "/insurance/user-page", icon: <SettingsOutlinedIcon /> },
  ];
}

export const isActive = (path, to) =>
  to === "/insurance/"
    ? path === "/" || path === "/insurance" || path === "/insurance/"
    : path.startsWith(to);
